
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import ChallengeCard from '../ChallengeCard.vue';
  import {Emit, Prop} from 'vue-property-decorator';
  import {ChallengeModel} from '@/models/challenge.model';
  import {bottomVisible} from '@/utils/utils';
  import {challengeModule} from '@/utils/store-acessor';
  import ListScaffold from '@/components/Shared/ListScaffold.vue';

  @Component({
    components: {ListScaffold, ChallengeCard}
  })
  export default class ChallengesSituationsTemplate extends Vue {
    @Prop({required: true}) challenges!: ChallengeModel[];
    @Prop({required: true}) loading!: boolean;

    mounted() {
      window.addEventListener('scroll', () => {
        if (bottomVisible()) {
          this.scrollInBottom()
        }
      })
    }

    openChallenge(slug: string) {
      this.$router.push(`/challenges/${slug}`)
    }

    @Emit()
    scrollInBottom(): boolean {
      return true
    }
  }
